module.exports = __webpack_public_path__ + "static/img/control-criticas.824ab5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguros-arl/Especialidades/control-criticas.png
// module id = idT1
// module chunks = 0